import { createIntl, createIntlCache } from '@formatjs/intl';

// Polyfills
import '@formatjs/intl-getcanonicallocales/polyfill.js';

import '@formatjs/intl-locale/polyfill.js';

// import '@formatjs/intl-numberformat/polyfill.js';
// import '@formatjs/intl-numberformat/locale-data/en.js'; // locale-data for en
// import '@formatjs/intl-numberformat/locale-data/fr.js'; // locale-data for fr
// import '@formatjs/intl-numberformat/locale-data/de.js'; // locale-data for de
// //
// import '@formatjs/intl-datetimeformat/polyfill.js';
// import '@formatjs/intl-datetimeformat/locale-data/en.js'; // locale-data for en
// import '@formatjs/intl-datetimeformat/locale-data/fr.js'; // locale-data for fr
// import '@formatjs/intl-datetimeformat/locale-data/de.js'; // locale-data for de
// import '@formatjs/intl-datetimeformat/add-all-tz.js' // Add ALL tz data

import '@formatjs/intl-pluralrules/polyfill.js';
// locale-data for the 24 official languages of the European Union
import '@formatjs/intl-pluralrules/locale-data/bg.js'; // locale-data for bg
import '@formatjs/intl-pluralrules/locale-data/cs.js'; // locale-data for cs
import '@formatjs/intl-pluralrules/locale-data/da.js'; // locale-data for da
import '@formatjs/intl-pluralrules/locale-data/de.js'; // locale-data for de
import '@formatjs/intl-pluralrules/locale-data/el.js'; // locale-data for el
import '@formatjs/intl-pluralrules/locale-data/en.js'; // locale-data for en
import '@formatjs/intl-pluralrules/locale-data/es.js'; // locale-data for es
import '@formatjs/intl-pluralrules/locale-data/et.js'; // locale-data for et
import '@formatjs/intl-pluralrules/locale-data/fi.js'; // locale-data for fi
import '@formatjs/intl-pluralrules/locale-data/fr.js'; // locale-data for fr
import '@formatjs/intl-pluralrules/locale-data/ga.js'; // locale-data for ga
import '@formatjs/intl-pluralrules/locale-data/hr.js'; // locale-data for hr
import '@formatjs/intl-pluralrules/locale-data/hu.js'; // locale-data for hu
import '@formatjs/intl-pluralrules/locale-data/it.js'; // locale-data for it
import '@formatjs/intl-pluralrules/locale-data/lt.js'; // locale-data for lt
import '@formatjs/intl-pluralrules/locale-data/lv.js'; // locale-data for lv
import '@formatjs/intl-pluralrules/locale-data/mt.js'; // locale-data for mt
import '@formatjs/intl-pluralrules/locale-data/nl.js'; // locale-data for nl
import '@formatjs/intl-pluralrules/locale-data/pl.js'; // locale-data for pl
import '@formatjs/intl-pluralrules/locale-data/pt.js'; // locale-data for pt
import '@formatjs/intl-pluralrules/locale-data/ro.js'; // locale-data for ro
import '@formatjs/intl-pluralrules/locale-data/sk.js'; // locale-data for sk
import '@formatjs/intl-pluralrules/locale-data/sl.js'; // locale-data for sl
import '@formatjs/intl-pluralrules/locale-data/sv.js'; // locale-data for sv

// Locales data
// import enData from './localizationData/en';
// import frData from './localizationData/fr';
// import esData from './localizationData/es';
// import ptData from './localizationData/pt';
// import itData from './localizationData/it';

export const localeDataAssociations = {
    // 'fr': frData,
    // 'en': enData,
    // 'es': esData,
    // 'pt': ptData,
    // 'it': itData,
};

// list of available languages: the 24 official languages of the European Union
export const enabledLanguages = [
    'fr',
    'en',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'et',
    'fi',
    'ga',
    'hr',
    'hu',
    'it',
    'lt',
    'lv',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'sl',
    'sv',
];
export const defaultLanguage = 'fr';

// ISO 639-1 language => ISO 3166-1 alpha-2 country (flags), only when both codes differ
export const languageCountryAssociations = {
    cs: 'CZ',
    da: 'DK',
    el: 'GR',
    en: 'GB',
    et: 'EE',
    ga: 'IE',
    sl: 'SI',
    sv: 'SE',
};

// this object will have language-specific data added to it which will be placed in the state when that language is active
// if localization data get to big, stop importing in all languages and switch to using API requests to load upon switching languages
export const localizationData = {};

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();

enabledLanguages.forEach(locale => {
    // Create the `intl` object
    localizationData[locale] = createIntl(
        {
            defaultLocale: 'en',
            locale,
            messages: [],
            ...(localeDataAssociations[locale] || {}),
        },
        // {
        //     // Locale of the application
        //     locale,
        //     // Locale of the fallback defaultMessage
        //     defaultLocale: 'en',
        //     messages: ,
        // },
        cache,
    );
});

// Block react-intl errors
if(process.env.NODE_ENV !== 'production') {
    const originalConsoleError = console.error;
    if(console.error === originalConsoleError) {
        console.error = (...args) => {
            if(args[0] && `${args[0].message}`.indexOf('[@formatjs/intl') === 0) {
                return;
            }
            originalConsoleError.call(console, ...args);
        };
    }
}
